import { Component, signal, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from '../portal/auth.store';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authStore = inject(AuthStore);
  
  email = signal('');
  password = signal('');
  loginError = signal('');

  async ngOnInit() {
    // Check if user is already logged in
    const isAuthenticated = await this.authStore.checkAuth();
    
    if (isAuthenticated) {
      // If user is already logged in, redirect to portal
      const next = this.route.snapshot.queryParamMap.get('next');
      const to = next && next.startsWith('/') && next !== '/portal/reactivate' ? next : '/portal';
      this.router.navigateByUrl(to);
    }
  }

  async login() {
    this.loginError.set('');
    
    const { session, error } = await this.authStore.signIn(
      this.email(),
      this.password()
    );
    
    if (session) {
      // If the guard sent us ?next=..., go there; otherwise default to /portal
      const next = this.route.snapshot.queryParamMap.get('next');
      const to = next && next.startsWith('/') ? next : '/portal';
      this.router.navigateByUrl(to);
    } else {
      this.loginError.set(error || 'Login failed');
    }
  }
}
